export default __webpack_public_path__ + "static/media/login_background.0db3538e.jpg";